import { TileOverlay } from '@mc/design-system'
import Image from 'components/LegacyImage'

interface HeroDesktopSingleImageTileProps {
  imgUrl: string
  imgAlt: string
}

export const HeroDesktopSingleImageTile = ({
  imgUrl,
  imgAlt,
}: HeroDesktopSingleImageTileProps) => (
  <div className='col-8 offset-4 d-flex'>
    <TileOverlay type='gradient-left' color='0,0,0' />
    <TileOverlay type='gradient-bottom' color='0,0,0' />
    <Image
      src={imgUrl}
      alt={imgAlt}
      width={912}
      height={600}
      objectPosition='center'
      objectFit='cover'
      priority
      fetchpriority='high'
    />
  </div>
)
